module.exports = __webpack_public_path__ + "2fa543d3dc491e31995107f04dd5199a.jpg";